<style src="../css/head.css"></style>

<style src="../css/detail.css"></style>

<template>
  <div>
    <Head-section></Head-section>
    <br><br>
    <div class="container">
    <div class="mt-3">
         <div class="mt-4">
          <b-card no-body class="overflow-hidden">
            <b-row no-gutters>
             <b-col md="5">
                <b-card-img
                  src="https://bluedio.com/img/comm/5a5b5a6a80ec8.jpg"
                  alt="Register For Warranty"
                  class="rounded-0"
                ></b-card-img>
              </b-col>
              <b-col md="7">
                <b-card-body title class="card-body-sytle">
                  <b-card-text>
                  <H1 align="center">{{ $t("message.Warranty_register_Title") }}</H1>
                  <p align="center" style="font-size:13px;" v-if="lan=='en'">{{ $t("message.Warranty_register_subTitle") }}</P>
                  <br><br>
                  <div>
                  <b-form>
                   <b-form-group id="input-group-1" label="" label-for="input-1">
                        <b-form-input
                        id="input-1"
                        v-model="form.name"
                        required
                        :placeholder="$t('message.Warranty_register_name')"
                        ></b-form-input>
                    </b-form-group>
                    <br>
                    <b-form-group id="input-group-2" label="" label-for="input-2">
                        <b-form-input
                        id="input-2"
                        v-model="form.mail"
                        type="email"
                        required
                        :placeholder="$t('message.Warranty_register_email')"
                        ></b-form-input> 
                    </b-form-group>
                    <br>
                    <b-input-group>
                        <b-form-input
                        id="input-3"
                        v-model="form.phone"
                        required
                        :placeholder="$t('message.Warranty_register_phone')"
                        ></b-form-input> 
                        &nbsp;&nbsp;
                        <b-form-select
                        id="input-4"
                        v-model="form.buyfrom"
                        :options="buyfrom"
                        required
                        ></b-form-select>
                    </b-input-group>
                    <br><br>
                    <b-form-group id="input-group-5" label="" label-for="input-5">
                        <b-form-select
                        id="input-5"
                        v-model="form.productid"
                        :options="products"
                        value-field="id"
                        text-field="productname"
                        required
                        ></b-form-select>
                    </b-form-group>
                    <br>
                    <b-input-group>
                        <b-form-input
                        id="input-6"
                        v-model="form.ordernum"
                        :placeholder="$t('message.Warranty_register_Ordernum')"
                        ></b-form-input> 
                        &nbsp;&nbsp;
                        <b-form-input
                        id="input-7"
                        v-model="form.serialnum"
                        :placeholder="$t('message.Warranty_register_Serialnum')"
                        ></b-form-input> 
                    </b-input-group>
                    <br><br>
                    <div style="text-align:center">
                        <b-button type="info" variant="primary"  @click="onSubmit">{{ $t("message.Warranty_register_submit") }}</b-button>
                    </div>
                    </b-form>
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </div>
         
        </div>
        <br><br><br><br>
        </div>
    <Foot-section></Foot-section>
  </div>
</template>

<script>
import HeadSection from "./HeadSection.vue";
import FootSection from "./FootSection.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Warranty",
  components: {
    HeadSection,
    FootSection
  },
  metaInfo() {
    return {
       title: this.$t("message.Bluedio_Mall") + " | Register Warranty",
       titleTemplate: "%s",
      meta: [
         {
          name: "keywords",
          content: "Register For Warranty",
        }
      ],
    };
  },
  data() {
    return {
        form: {
          name: '',
          mail: '',
          phone: '',
          productid: 0,
          ordernum: '',
          serialnum: '',
          buyfrom: null
        },
        buyfrom: [{ text: this.$t("message.Warranty_register_buyfrom"), value: null }, 'Bluedio official store', 'Amazon', 'AliExpress', 'eBay', 'Others'],
        products: [],
        show: true
      }
  },
  created() {
    let language = this.$route.params.language;
    if(this.$store.state.lan_array.indexOf(language) == -1){
      this.toHome();
    }
    this.getPdLsByCategry();
  },
  methods: {
     ...mapActions({
      warrantySave(dispatch, name, mail, phone, buyfrom, productid, ordernum, serialnum) {
        dispatch("warrantySave", {
          name, mail, phone, buyfrom, productid, ordernum, serialnum
        }).then((data) => {
          if (data.result) {
            this.form.name = '';
            this.form.mail =  '';
            this.form.phone = '';
            this.form.productid = 0;
            this.form.ordernum = '';
            this.form.serialnum = '';
            this.form.buyfrom = null;
          }
          this.showToast(data.message);
        });
      },
       getPdLsByCategry(dispatch) {
         let ctgid = 0;
         let pg = 0;
         let pgs = 200;
         let load = 0;
        dispatch("getPdLsByCategry", {
          ctgid,
          pg,
          pgs,
          load
        }).then(data => {
          if (data.result) {
            this.products = data.items;
            let firstE = {active:1,activestatus:'',description:'',id:0,images:[],location:'en',ordernum:1,productname:this.$t("message.Warranty_register_product"),producttype:0,skus:[]};
            this.products.unshift(firstE);
          }
        });
      },
     }),
    showToast(msg) {
      this.$bvToast.toast(msg, {
        title: ``,
        toaster: "b-toaster-bottom-center",
        solid: true,
        variant: "danger",
        appendToast: false
      });
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.warrantySave(this.form.name, this.form.mail, this.form.phone, this.form.buyfrom, this.form.productid, this.form.ordernum, this.form.serialnum);
    },
    toHome() {
      let nameHome = this.lan + "home";
      this.$router.replace({
        name: nameHome
      });
    },
  },
  computed: mapGetters(["lan_array"]),

  watch: {
  }
};
</script>
